module.exports = __webpack_public_path__ + "img/电子.70d9e353.png";